const pool = (state = {}, action) => {
	switch (action.type) {
		case 'POOL_ROLE_ACCESS':
		case 'SET_USER_POOL':
			return { ...state, ...action.data };
		case 'USER_LOGOUT':
			return {};
		default:
			return state;
	}
};
export default pool;
